import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';
import Accordion from './Accordion';
import Loader from '../Loader';
import Item from './Item';

const isAllChecked = items => {
  if (items && items[0].options) {
    const options = [];
    items.forEach(item => {
      item.options.forEach(option => {
        options.push(option);
      });
    });
    return options.every(option => option.checked);
  }
  return items.every(item => item.checked);
};

const isSomeChecked = items => {
  if (items && items[0].options) {
    const options = [];
    items.forEach(item => {
      item.options.forEach(option => {
        options.push(option);
      });
    });
    return options.some(option => option.checked);
  }
  return items.some(item => item.checked);
};

const renderOption = (option, selectOption, leftCheckbox) => {
  return (
    <Item key={option.id} option={option} selectOption={selectOption} leftCheckbox={leftCheckbox} />
  );
};

const renderOptionWithAccordion = (
  option,
  selectOption,
  toggleAllItemsInAccordion,
  leftCheckbox
) => {
  return (
    <Accordion
      key={option.id}
      data={option}
      selectOption={selectOption}
      options={option.options}
      leftCheckbox={leftCheckbox}
      toggleAllItemsInAccordion={toggleAllItemsInAccordion}
    />
  );
};

const renderSelectAll = (toggleAll, options) => {
  const someChecked = isSomeChecked(options);
  return (
    <Item
      option={{
        name: someChecked ? 'Limpar Seleção' : 'Selecionar Todos',
        checked: isAllChecked(options),
        someChecked,
      }}
      selectOption={toggleAll}
      leftCheckbox
      selectAll
    />
  );
};

const GenericSelectList = ({
  isLoading,
  options,
  hasAccordion,
  selectOption,
  leftCheckbox,
  toggleAll,
  toggleAllItemsInAccordion,
}) => {
  return (
    <styles.Container>
      <styles.List>
        {isLoading ? (
          <styles.LoaderContainer>
            <Loader show={true} />
          </styles.LoaderContainer>
        ) : (
          <Fragment>
            {toggleAll && renderSelectAll(toggleAll, options)}
            {options.map(opt =>
              hasAccordion
                ? renderOptionWithAccordion(
                    opt,
                    selectOption,
                    toggleAllItemsInAccordion,
                    leftCheckbox
                  )
                : renderOption(opt, selectOption, leftCheckbox)
            )}
          </Fragment>
        )}
      </styles.List>
    </styles.Container>
  );
};

GenericSelectList.propTypes = {
  isLoading: PropTypes.bool,
  options: PropTypes.array,
  hasAccordion: PropTypes.bool,
  leftCheckbox: PropTypes.bool,
  selectOption: PropTypes.func,
  toggleAll: PropTypes.func,
  toggleAllItemsInAccordion: PropTypes.func,
};

GenericSelectList.defaultProps = {
  hasAccordion: false,
  isLoading: false,
  leftCheckbox: false,
  toggleAll: null,
  toggleAllItemsInAccordion: null,
};

export default GenericSelectList;



// WEBPACK FOOTER //
// ./src/components/GenericSelectList/index.js